/**
 * Resets the form error state by clearing aria-invalid attributes and error messages.
 * @param {HTMLElement} container - The container element that holds the form fields.
 * @public
 * @returns {void}
 */
const resetFormErrorState = (container) => {
	const ariaInvalidFields = Array.from(
		container.querySelectorAll("[aria-invalid=true]"),
	);
	const validationErrorContainers = Array.from(
		container.querySelectorAll(".Form-fieldGroupError"),
	);

	if (ariaInvalidFields) {
		ariaInvalidFields.forEach((field) => {
			field.setAttribute("aria-invalid", false);
		});
	}

	if (validationErrorContainers) {
		validationErrorContainers.forEach((container) => {
			container.querySelector("span").textContent = "";
			container.classList.remove("Form-fieldGroupError--show");
		});
	}
};

export { resetFormErrorState };
